<template>
  <section>
    <!--新增-->
    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="addForm" label-width="150px" ref="addForm" size="small">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.'+slot.langkey"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Name')}"
            >
              <el-input v-model="addForm.Name[slot.langkey]" style="width:200px"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Sort')"
              prop="Sort"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Sort')}"
            >
              <el-input type="number" v-model.number="addForm.Sort" style="width:200px"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Product.ItemQTY')"
              prop="ItemQTY"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Product.ItemQTY')}"
            >
              <el-input-number
                v-model.number="addForm.ItemQTY"
                :precision="0"
                :step="1"
                :min="0"
                :max="99"
                style="width:200px"
              ></el-input-number>
              <span class="span_suffix">0为不限</span>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="addForm.Enabled"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('Items')">
              <el-button
                type="success"
                size="mini"
                icon="fa fa-plus"
                @click="addItemEvent(true)"
              >{{$t('add')}}</el-button>
              <el-table :data="addForm.ProductSpecList" style="width: 100%;">
                <el-table-column :label="$t('Sort')" prop="Sort" width="80"></el-table-column>
                <el-table-column :label="$t('Name')">
                  <template slot-scope="scope">{{field(scope.row.Name)}}</template>
                </el-table-column>
                <el-table-column :label="$t('Price')" width="120" prop="Price">
                  <template slot-scope="scope">
                    <span class="text_red">$ {{scope.row.Price}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Enabled" :label="$t('Enabled')" width="90">
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.Enabled  ? 'success' : 'danger'"
                      disable-transitions
                    >{{scope.row.Enabled ? $t('enabled'):$t('disable')}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('operation')" width="125">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="editSpec(scope.$index,scope.row,true)"
                      icon="el-icon-edit"
                    ></el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="deleteRealSpec(scope.$index)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">{{$t('submit')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('add')"
      :visible.sync="addFormItemVisible"
      v-model="addFormItemVisible"
      :close-on-click-modal="false"
      append-to-body
      width="30%"
    >
      <el-form :model="addFormItem" label-width="80px" ref="addFormItem" size="small">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Sort')"
              prop="Sort"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Sort')}"
            >
              <el-input type="number" v-model.number="addFormItem.Sort" style="width:200px"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.'+slot.langkey"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Name')}"
            >
              <el-input v-model="addFormItem.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Price')"
              prop="Price"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Price')}"
            >
              <el-input-number
                v-model.number="addFormItem.Price"
                :precision="2"
                :step="0.1"
                :max="9999"
                style="width:195px"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="addFormItem.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addFormItem.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormItemVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click.native="addSpecSubmit">{{$t('submit')}}</el-button>
      </div>
    </el-dialog>

    <!--修改-->
    <el-dialog
      :title="$t('edit')"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form :model="editForm" label-width="150px" ref="editForm" size="small">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.'+slot.langkey"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Name')}"
            >
              <el-input v-model="editForm.Name[slot.langkey]" style="width:200px"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Sort')"
              prop="Sort"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Sort')}"
            >
              <el-input type="number" v-model.number="editForm.Sort" style="width:200px"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Product.ItemQTY')"
              prop="ItemQTY"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Product.ItemQTY')}"
            >
              <el-input-number
                v-model.number="editForm.ItemQTY"
                :precision="0"
                :step="1"
                :min="0"
                :max="99"
                style="width:200px"
              ></el-input-number>
              <span class="span_suffix">0为不限</span>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="editForm.Enabled"></el-switch>
            </el-form-item>
            <el-form-item :label="$t('Items')">
              <el-button
                type="success"
                size="mini"
                icon="fa fa-plus"
                @click="addItemEvent(false)"
              >{{$t('add')}}</el-button>
              <el-table :data="editList()" style="width: 100%;">
                <el-table-column :label="$t('Sort')" prop="Sort" width="80"></el-table-column>
                <el-table-column :label="$t('Name')">
                  <template slot-scope="scope">{{field(scope.row.Name)}}</template>
                </el-table-column>
                <el-table-column :label="$t('Price')" width="120" prop="Price">
                  <template slot-scope="scope">
                    <span class="text_red">$ {{scope.row.Price}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Enabled" :label="$t('Enabled')" width="90">
                  <template slot-scope="scope">
                    <el-tag
                      :type="scope.row.Enabled  ? 'success' : 'danger'"
                      disable-transitions
                    >{{scope.row.Enabled ? $t('enabled'):$t('disable')}}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('operation')" width="125">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="editSpec(scope.$index,scope.row,false)"
                      icon="el-icon-edit"
                    ></el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      icon="el-icon-delete"
                      @click="deleteSpec(scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="addForm.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">{{$t('submit')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="$t('add')"
      :visible.sync="editFormItemVisible"
      v-model="editFormItemVisible"
      :close-on-click-modal="false"
      append-to-body
      width="30%"
    >
      <el-form :model="editFormItem" label-width="80px" ref="editFormItem" size="small">
        <LangTabs>
          <template v-slot:main="slot">
            <el-form-item
              :label="$t('Sort')"
              prop="Sort"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Sort')}"
            >
              <el-input type="number" v-model.number="editFormItem.Sort" style="width:200px"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Name')"
              :prop="'Name.'+slot.langkey"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Name')}"
            >
              <el-input v-model="editFormItem.Name[slot.langkey]"></el-input>
            </el-form-item>
            <el-form-item
              :label="$t('Price')"
              prop="Price"
              :rules="{required: true, message: $t('pleaseEnter')+$t('Price')}"
            >
              <el-input-number
                v-model.number="editFormItem.Price"
                :precision="2"
                :step="0.1"
                :min="0"
                :max="9999"
                style="width:200px"
              ></el-input-number>
            </el-form-item>
            <el-form-item :label="$t('Enabled')">
              <el-switch v-model="editFormItem.Enabled"></el-switch>
            </el-form-item>
          </template>
          <template v-slot:other="slot">
            <el-form-item :label="$t('Name')">
              <el-input v-model="editFormItem.Name[slot.item.key]"></el-input>
            </el-form-item>
          </template>
        </LangTabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormItemVisible = false">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click.native="editSpecSubmit">{{$t('submit')}}</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "util/date";
import {
  getProductSpecTypeListPage,
  removeProductSpecType,
  editProductSpecType,
  addProductSpecType,
  addAllProductSpecType,
} from "@/api/api";
import { getButtonList } from "@/promissionRouter";
export default {
  data() {
    return {
      pid: 0,
      buttonList: [],
      list: [],
      listLoading: false,
      currentRow: null,
      dialogVisible: false,
      //新增界面数据
      addFormVisible: false,
      addFormItemVisible: false,
      addLoading: false,
      addForm: { Name: {}, ProductSpecList: [] },
      addFormItem: {},
      //修改界面数据
      editFormVisible: false,
      editFormItemVisible: false,
      editLoading: false,
      editForm: {},
      editFormItem: {},
      isAdd: true,
    };
  },
  inject: ["getProductBasis", "getProductList"],
  methods: {
    editList() {
      return this.editForm.ProductSpecList.filter((item) => !item.IsDeleted);
    },
    formatDate: function (val) {
      return util.formatDate.format(new Date(val), "yyyy/MM/dd hh:mm");
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    closeDialog() {
      this.getProductBasis();
    },
    addItemEvent(isadd) {
      this.isAdd = isadd;
      this.addFormItem = {
        Sort: 0,
        Name: {},
        Price: 0.0,
        Enabled: true,
      };
      this.addFormItemVisible = true;
    },
    addSpecSubmit() {
      let _this = this;
      this.$refs.addFormItem.validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            this.addForm.ProductSpecList.push(this.addFormItem);
          } else {
            this.editForm.ProductSpecList.push(this.addFormItem);
          }
          this.addFormItemVisible = false;
        }
      });
    },
    editSpec(index, row, isadd) {
      this.isAdd = isadd;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormItemVisible = true;
      this.editFormItem = Object.assign({ index: index }, this.clone(row));
    },
    editSpecSubmit() {
      this.$refs.editFormItem.validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            this.addForm.ProductSpecList.splice(
              this.editFormItem.index,
              1,
              this.editFormItem
            );
          } else {
            this.editForm.ProductSpecList.splice(
              this.editFormItem.index,
              1,
              this.editFormItem
            );
          }
          this.editFormItemVisible = false;
        }
      });
    },
    deleteRealSpec(index) {
      this.addForm.ProductSpecList.splice(index, 1);
    },
    deleteSpec(row) {
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          row.IsDeleted = true;
        })
        .catch(() => {});
    },
    handleAllAdd(prolist) {
      this.addFormVisible = true;
      this.addForm = {
        Sort: 0,
        Name: {},
        Enabled: true,
        ProductSpecList: [],
        ProductList: prolist,
      };
    },
    //显示新增界面
    handleAdd(id) {
      this.addFormVisible = true;
      this.addForm = {
        Sort: 0,
        Name: {},
        ItemQTY: 0,
        Product_Id: id,
        Enabled: true,
        ProductSpecList: [],
        ProductList: [],
      };
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.addLoading = true;
              let para = Object.assign({}, this.addForm);
              if (this.addForm.ProductList.length > 0) {
                addAllProductSpecType(para).then((res) => {
                  this.addLoading = false;
                  if (util.isEmt.format(res)) {
                    return;
                  }
                  if (res.data.success) {
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                    this.$refs["addForm"].resetFields();
                    this.addFormVisible = false;
                    this.getProductList();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                });
              } else {
                addProductSpecType(para).then((res) => {
                  this.addLoading = false;
                  if (util.isEmt.format(res)) {
                    return;
                  }
                  if (res.data.success) {
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                    this.$refs["addForm"].resetFields();
                    this.addFormVisible = false;
                    this.getProductList();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                });
              }
            })
            .catch(() => {});
        }
      });
    },
    //显示编辑活动界面
    handleEdit(row) {
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, this.clone(row));
    },
    //编辑活动
    editSubmit: function () {
      let _this = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t("submitPrompt"), this.$t("prompt"), {})
            .then(() => {
              this.editLoading = true;
              let para = Object.assign({}, this.editForm);
              editProductSpecType(para).then((res) => {
                this.editLoading = false;
                if (util.isEmt.format(res)) {
                  return;
                }
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getProductList();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: this.$t("selectRow"),
          type: "error",
        });

        return;
      }
      this.$confirm(this.$t("deletePrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.Id };
          removeProductSpecType(para).then((res) => {
            this.listLoading = false;
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>
